/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TemplateStoreContainer as TemplateStore } from './TemplateStore.container';
